import React from 'react';
import { useTranslation } from 'react-i18next';

import Error from './Error';

type NetworkErrorType = {
	onReload: () => void;
};

const NetworkError: React.FC<NetworkErrorType> = ({ onReload }) => {
	const { t } = useTranslation();
	return (
		<Error
			title={t('somethingWentWrong')}
			content={t('reloadText')}
			onReload={onReload}
		/>
	);
};

export default NetworkError;
